import { Value } from 'slate';
import {
  BASIC_INPUT_DEFAULT_VALUE,
  PERSON_DEFAULT_VALUE,
  AFFILIATIONS_DEFAULT_VALUE,
  BASICARRAYINPUT_DEFAULT_VALUE,
  REFERENCES_DEFAULT_VALUE,
  DATE_INPUT_DEFAULT_VALUE,
  USER_PREFERENCES,
} from '../constants/editJournalDefaultValues';
import { getEditorRef } from '../../components/userDocuments/editDocument/shared/editorRefs/getEditorRefs';
import { SET_JOURNAL_INITIAL_STATE } from '../actions/actionTypes/editJournalForm';

const getParsedData = (paragraphComponents) => {
  const parsedData = JSON.parse(paragraphComponents);
  const parsedParagraphComponents = {};
  [...Object.keys(parsedData)].forEach((key) => {
    if (key !== 'parents') {
      const val = Value.fromJSON(JSON.parse(parsedData[key].value));
      parsedParagraphComponents[key] = {
        ...parsedData[key],
        value: val,
      };
    } else {
      parsedParagraphComponents[key] = { ...parsedData[key] };
    }
  });
  return parsedParagraphComponents;
};

const getEditJournalData = (data, paragraphComponents) => ({
  templateType: data.templateType || null,
  permissions: data.permissions,
  documentName: data.documentName,
  status: 0,
  title: data.title ? data.title : BASIC_INPUT_DEFAULT_VALUE,
  subtitle: data.subtitle ? data.subtitle : BASIC_INPUT_DEFAULT_VALUE,
  sponsor: data.sponsor ? data.sponsor : BASIC_INPUT_DEFAULT_VALUE,
  subject: data.subject ? data.subject : BASIC_INPUT_DEFAULT_VALUE,
  email: data.email ? data.email : BASIC_INPUT_DEFAULT_VALUE,
  publishedDate:
    data.publishedDate !== undefined
      ? data.publishedDate
      : DATE_INPUT_DEFAULT_VALUE,
  authors: data.authors ? data.authors : PERSON_DEFAULT_VALUE,
  professors: data.professors ? data.professors : PERSON_DEFAULT_VALUE,
  affiliations: data.affiliations
    ? data.affiliations
    : AFFILIATIONS_DEFAULT_VALUE,
  keywords: data.keywords ? data.keywords : BASICARRAYINPUT_DEFAULT_VALUE,
  notes: data.notes ? data.notes : BASICARRAYINPUT_DEFAULT_VALUE,
  references: data.references ? data.references : REFERENCES_DEFAULT_VALUE,
  paragraphComponents: data.paragraphComponents
    ? { ...paragraphComponents, ...getParsedData(data.paragraphComponents) }
    : { ...paragraphComponents },
  parents: data.parents ? data.parents : null,
  userPreferences: data.userPreferences || USER_PREFERENCES,
});

export default (params) => {
  const { documentData, formatType } = params;
  const editorRefs = getEditorRef(documentData.templateType);
  const paragraphComponents = {
    ...[...Object.values(editorRefs)].map((editorRef) => ({
      ...editorRef,
      /**
       * overwriting editorRefs editorRef value to null
       * because it is not useful inside paragraphComponents object
       */
      editorRef: null,
    })),
  };

  const editJournalInitialState = getEditJournalData(
    documentData,
    paragraphComponents,
  );

  return {
    ...editJournalInitialState,
    eventType: SET_JOURNAL_INITIAL_STATE,
    formatType,
    history: {
      tail: {
        data: { ...editJournalInitialState },
        next: null,
        prev: null,
        index: 0,
        changedData: [],
      },
    },
    counter: {},
  };
};
